import React from 'react'
import glamorousBanner from "./../../../../../Images/Blog/Get Ready for a Glamorous Night/Banner.png";

const GlamorousImg = () => {
  return (
    <div className="blogImg-content">
    <img src={glamorousBanner} alt="glamorousBanner" loading="lazy"/>
  </div>
  )
}

export default GlamorousImg
